var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"pa-0",attrs:{"items":_vm.data},scopedSlots:_vm._u([{key:"divider",fn:function(){return [(_vm.$vuetify.rtl == false)?_c('v-icon',[_vm._v("mdi-chevron-right")]):_vm._e(),(_vm.$vuetify.rtl == true)?_c('v-icon',[_vm._v("mdi-chevron-left")]):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }